/* global localStorage */

export const clearCredentials = () => {
    localStorage.clear()
}

export const setCredentials = auth => {
    localStorage.setItem('kndAuth', JSON.stringify(auth))
}

export const getCredentials = () => {
return JSON.parse(localStorage.getItem('kndAuth'))
}
  